/* eslint-disable react/no-danger */
import React from 'react';
import { HeaderCompanies } from './styles/TypesOfCompaniesBlock.styled';
import { Container } from './styles/Container.styled';

export default function CompaniesTypesHeader({ data }) {
  const { title, description } = data;
  return (
    <HeaderCompanies>
      <Container>
        {title && <h2>{title}</h2>}
        {description && (
          <p dangerouslySetInnerHTML={{ __html: description.replace(/\n/g, '<br />') }} />
        )}
      </Container>
    </HeaderCompanies>
  );
}
